
import { defineComponent } from "vue";
import loadingRing from "@/components/loadingRing.vue";

export default defineComponent({
  components: { loadingRing },
});
